/* eslint-disable react/jsx-filename-extension */
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import {WrapRootElementBrowserArgs, ShouldUpdateScrollArgs} from 'gatsby';

import {ErrorReporter} from './src/lib/errorReporter';
import CustomLayout from './wrapPageElement';
import {setFaid, gclid, sendEvent, hubspot} from './src/lib/front';

// This is mainly added for filters to keep the scroll position after
// selecting/unselecting options.
export const shouldUpdateScroll = ({routerProps, prevRouterProps}: ShouldUpdateScrollArgs) => {
  if (!prevRouterProps)
    return false;

  const {pathname: prevPathname} = prevRouterProps.location;
  const {pathname: currentPathname} = routerProps.location;

  return prevPathname !== currentPathname;
};

export const wrapRootElement = ({element}: WrapRootElementBrowserArgs) => <ErrorReporter>{element}</ErrorReporter>;

export const wrapPageElement = CustomLayout;

// Stores previousPath on window object
export const onRouteUpdate = () => {
  window.locations = window.locations || [document.referrer];
  window.locations.push(window.location.href);
  window.previousPath = window.locations[window.locations.length - 2];
};

export const onInitialClientRender = () => {
  setFaid();

  // Track GCLID
  if (gclid.current()) {
    gclid.record();
    sendEvent('gclid', gclid.get());
  }

  // Segment Analytics.
  if (window.analytics) {
    const properties: { referrer?: string; } = {};
    const {search} = window.location;

    if (search.indexOf('referrer=') >= 0) {
      properties.referrer = search.split('referrer=')[1].split('&')[0]; // eslint-disable-line prefer-destructuring

      // FIXME: We need this fix until Segment updates their code for referrer tracking in GA
      // cf. https://github.com/segment-integrations/analytics.js-integration-google-analytics/pull/23
      if (window.ga)
        window.ga('set', 'referrer', properties.referrer);
    }

    if (window.ga)
      window.ga(tracker => {
        if (!tracker)
          return;

        const clientId = tracker.get('clientId');

        window.analytics.identify({client_id: clientId});
        window.analytics.page(properties);
      });
    else
      window.analytics.page(properties);
  }

  // Drift
  if (window.drift && window.drift.on) {
    window.drift.on('scheduling:meetingBooked', (data: {
      conversationId?: number;
    }) => {
      const userEmail = window.localStorage.getItem('drift-email');

      if (userEmail && data.conversationId)
        hubspot.trackDemo({email: userEmail, conversationId: data.conversationId});

      sendEvent('demo-request');
    });

    window.drift.on('emailCapture', ({data: {email}}: {data: {email: string}}) => {
      hubspot._hsq().push(['identify', {email}]); // eslint-disable-line no-underscore-dangle
      window.localStorage.setItem('drift-email', email);
    });
  }
};
